import functions from "./functions";
import Slider from "./Slider";
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js';
import {SimpleGuests, SimpleGuestsDefaults} from "./simple-guests.js";

SimpleGuestsDefaults.adultsLabel = 'Adults +18 years';
SimpleGuestsDefaults.childrenLabel = 'Children 12-$y years';
SimpleGuestsDefaults.infantsLabel = 'Children up to $y years';

$(function() {

    if (functions.isMobile()) 
    {
        $('.show-on-desktop').remove();
        $('.show-on-mobile').removeClass('d-none');
    }
    else 
    {
        $('.show-on-mobile').remove();
        $('.show-on-desktop').removeClass('d-none');
    }

    $('#navbarTogglerMain').on('show.bs.collapse', e => {
        $('header .navbar').addClass('bg-dark');
    });
    $('#navbarTogglerMain').on('hide.bs.collapse', e => {
        $('header .navbar').removeClass('bg-dark');
    });

    $('body').on('click', '.dropdown-menu', e => {
        e.stopPropagation();
    });

    functions.markFavourites();
    functions.addToFavourites();


    function count($this, num) {
        var current = parseInt($this.html(), 10);
        current += num;
        $this.html(current);
        if (current > $this.attr('data-count')) {
            $this.html($this.attr('data-count'));
        }
        else {
            setTimeout(function () { count($this, num) }, 60);
        }
    }
    setTimeout(function(){
        $(".verified-villas-cnt").each(function () {
            // parse with a base 10 and save to a data atr
            var totalvillas = $('.search-form.hero-form').attr('data-totalvillanum');
            $(this).attr('data-count', parseInt(totalvillas, 10));
            $(this).html('0');
            count($(this), 10);
        });

        $(".satisfied-guests-cnt").each(function () {
            // parse with a base 10 and save to a data atr
            var totalpersons = $('.search-form.hero-form').attr('data-totalpersonsnum');
            $(this).attr('data-count', parseInt(totalpersons, 10));
            $(this).html('0');
            count($(this), 2000);
        });
    }, 400);


    // modal !!!!
    let modalOpen = false;
    const myModalEl = document.getElementById('homeSearchModal')

    if(myModalEl) {
        const myModal = new bootstrap.Modal(myModalEl, {
            focus: false,
        });
        myModalEl.addEventListener('hidden.bs.modal', function () {
            modalOpen = false;
        });
        $('#showSearchForm').on('click', e=> {
            if ( !modalOpen ) {
                myModal.show();
                modalOpen = true;
            } else {
                myModal.hide();
            }
        });

        $(myModalEl).on('shown.bs.modal', e => {
            $('.modal-backdrop').addClass('home-search-backdrop');
            $('.modal-open').addClass('home-search-modal-open');
        });
    }

    $('.modal:not(.modal-home)').on('shown.bs.modal', e => {
        $('.modal-backdrop').attr('style', 'opacity: 0.5 !important;');
    })

    $('.show-more').each( (i, elem) => {
        let $showMore = $(elem);

        if ($showMore.find('.show-more-content').outerHeight() < 150)
        {
            $showMore.addClass('removeBefore');
            $showMore.next('.show-more-expand').remove();
            return;
        }
        let height = $showMore.attr('data-height');
        let $breakpoint = $showMore.find('.show-more-breakpoint');
        if (height)
        {
            $showMore.css('max-height', +height);
        }
        else if ($breakpoint.length) 
        {
            $showMore.css('max-height', $breakpoint.offset().top - $showMore.offset().top - 25);
        }
        else 
        {
            let $maxHeight = functions.isMobile() ? 
                        ($showMore.outerHeight() * 0.15) : 
                        ($showMore.outerHeight() * 0.3);

            $showMore.css('max-height', $maxHeight);
        }
    
        $showMore.next('.show-more-expand').on('click', e => {
            let $prevSibling = $(e.currentTarget).prev();
            let $maxHeight
            if ($prevSibling.hasClass('removeBefore'))
            {
                let height = $prevSibling.attr('data-height');
                let $breakpoint = $prevSibling.find('.show-more-breakpoint');
                if (height)
                {
                    $maxHeight = +height;
                }
                else if ($breakpoint.length) 
                {
                    $maxHeight = $breakpoint.offset().top - $showMore.offset().top - 25;
                }
                else 
                {
                    $maxHeight = functions.isMobile() ? 
                        ($prevSibling.outerHeight() * 0.15) : 
                        ($prevSibling.outerHeight() * 0.3);
                }
                $prevSibling.css('max-height', $maxHeight);
                $prevSibling.removeClass('removeBefore');
                if ($prevSibling.hasClass('show-more-scroll')) 
                {
                    $('html, body').stop().animate({
                        scrollTop: $prevSibling.offset().top + $maxHeight - $(e.target).outerHeight(),
                    }, 0, 'linear');
                }
            }
            else 
            {
                let $content = $prevSibling.find('.show-more-content');
                $prevSibling.css('max-height', $content.outerHeight());
                $prevSibling.addClass('removeBefore');
            }
        })
    });

    if(! $('.page-type-details')[0]) {
        $(window).scroll(e => {
            $(window).scrollTop() > 0 
            ? $('#navbarTogglerMain').addClass('visible')
            : $('#navbarTogglerMain').removeClass('visible');
        });
    }


    $('.simple-guests').each((i, elem) => {
		elem._simpleGuests = new SimpleGuests(elem);
	});

    // $('[name="dates"]').on('change', e => {
    //     let dates = $(e.target).val();
    //     let datesSplited = dates.split(' - ');
    //     if(datesSplited.length == 2) functions.setCookie('user_dates', dates);
        
    // });

    $('[name="persons"]').on('change', e => {
        functions.setCookie('user_guests', $(e.target).val());
    });


    $(document).on('click', '[data-scroll-to]', e => {
        e.preventDefault();
        const $this = $(e.target);
        let scrollTo = $this.attr('data-scroll-to').split(',');
        functions.scrollToElement(scrollTo[0], scrollTo[1] || 0);
    });

    // Home find villa by name in nav bar
    $('#search-villa').on('submit', e => {
        e.preventDefault();
        let data = $.param(functions.getFormData($('#search-villa')));
        let toHash = true;
        let href = location.protocol + '//' + location.host + $('#search-villa').attr('action');
        if ( data ) {
            href += (href.indexOf('?') === -1 ? (toHash ? '#' : '?') : '&');
        }
        href += data;
        location.href = href; 
    });

    

    // home hero slider
    if($('#hero-slider')[0]) {
        new Slider('#hero-slider', {
            fade: true,
            loop: true,
            arrows: true,
            //autoplay: 2000,
            renderMode: "custom",
            slides: {
                perView: 1,
            },
        });
    }

    let homeSlider = [];
    $('[id=home-slider]').each((i, elem) => {
        const $slides = $(elem).find('.keen-slider__slide');
        homeSlider[i] = new Slider('#' + $(elem).attr('id'), {
            loop: true,
            fade: true,
            arrows: false,
            slides: {
                perView: 1,
            },
            autoplay: 6000,
            defaultAnimation: {
                duration: 0
            },
            detailsChanged: (s) => {
              s.slides.forEach((element, idx) => {
                if ( s.track.details.slides[idx].portion == 0 ) {
                    element.style.opacity = 0;
                }
                if ( s.track.details.slides[idx].portion == 1 ) {
                    element.style.opacity = 1;
                    element.classList.add('animation');
                }
              })
            },
            renderMode: "custom",
        });

        $slides.each((i, slide) => {
            slide.addEventListener('animationend', () => {
                slide.classList.remove('animation');
            });
        });
    });
    
    // destinations slider
    $('[id=destinations-slider]').each((i, elem) => {
        let $items =  $(elem).find('.keen-slider__slide');
        new Slider(elem, {
            loop: true,
            arrows: true,
            //autoplay: 6000,
            slides : {
                perView: 5,
                spacing: 20,
            },
            breakpoints: {
                '(max-width: 1360px)': {
                    slides : {
                        perView: 4,
                        spacing: 20,
                    },
                },
                '(max-width: 768px)': {
                    slides : {
                        perView: 3.25,
                        spacing: 10,
                        },
                    },
                    '(max-width: 576px)': {
                        slides : {
                            perView: 2.20,
                            spacing: 10,
                        },
                    },
            },

        });
    });

    $('[id=details-slider]').each((i, elem) => {
        let $items =  $(elem).find('.keen-slider__slide');
        new Slider(elem, {
            loop: true,
            fade: true,
            arrows: true,
            slides: {
                perView: 1,
            },
            autoplay: 6000,
            //autoplay: 0,
            defaultAnimation: {
              duration: 1500,
            },
            detailsChanged: (s) => {
              s.slides.forEach((element, idx) => {
                element.style.opacity = s.track.details.slides[idx].portion
              })
            },
            renderMode: "custom",
        });

    });

   // special offer slider varijanta 1
   $('[id=special-offer-slider]').each((i, elem) => {
        let $items =  $(elem).find('.keen-slider__slide');
        new Slider(elem, {
            loop: true,
            arrows: true,
            pager: true,
            slides : {
                perView: 4,
                spacing: 10,
            },
            breakpoints: {
                '(max-width: 1360px)': {
                    slides : {
                        perView: 3,
                        spacing: 10,
                    },
                },
                '(max-width: 992px)': {
                    slides : {
                        perView: 2.1,
                        spacing: 15,
                    },
                },
                '(max-width: 768px)': {
                    slides : {
                        perView: 1.08,
                        spacing: 15,
                        },
                    },
            },

        });
        });
   // special offer slider varijanta 2
   $('[id=offer-slider]').each((i, elem) => {
        let $items =  $(elem).find('.keen-slider__slide');
        new Slider(elem, {
            loop: true,
            arrows: true,
            pager: true,
            slides : {
                perView: 3,
                spacing: 20,
            },
        /*  breakpoints: {
                '(max-width: 992px)': {
                    slides : {
                        perView: 1.05,
                        spacing: 15,
                    },
                },
            },*/

        });
    });




    // select2 templates can be defined as data-template="destinations" ...
    const selectTemplates = {
        destinations: data => {
            if ( !data.element ) {
                return data.text;
            }
            if(data.placeId && data.placeName) {
                //const $element = $(data.element).addClass(data.element.className).text(data.placeName);
                const $element = $('<span>').addClass(data.element.className).text(data.placeName);
                return $element;
            }
            if(data.text) {
                const $element = $('<span>').addClass(data.element.className).text(data.text);
                let elemClass;
                switch ( (data.id).split(':').length ) {
                    case 1: elemClass = 'pl-2 font-weight-bolder'; break;
                    case 2: elemClass = 'pl-3 font-weight-bolder'; break;
                    case 3: elemClass = 'pl-3 font-weight-bolder'; break;
                    case 4: elemClass = 'pl-4'; break;
                    default: elemClass = 'h5'; break;
                }
                $element.addClass(elemClass);
                return $element;
            }
        },
    };

    // global init select2
    // data-templates
    // data-data
    // data-allow-clear
    // data-nosearch
    // placeholder
    $.map($('.select2'), elem => {
        const $elem = $(elem);
        const config = { dropdownParent: $elem.parent(), language: functions.getLang() };
        config.allowClear = $elem.attr('data-allow-clear');

        // find select2 which has an attribute data-data
        const data = $elem.attr('data-data');
        if ( data ) {
            try {
                config.data = JSON.parse(data);
            } catch (e) {}
        } 
        else if ( $elem.attr('data-special') ) {
            let newData = $('body').attr('data-select-' + $elem.attr('data-special'));
            config.data = JSON.parse(newData);
        }

        if ( $elem.attr('data-template') ) {
            config.templateResult = selectTemplates[$elem.attr('data-template')];
        }
        if ( $elem.attr('data-template-selection') ) {
            config.templateSelection = selectTemplates[$elem.attr('data-template-selection')];
        }

        if ( $elem.attr('data-nosearch') !== undefined ) {
            config.minimumResultsForSearch = Infinity;
        }

        let placeholder = $elem.attr('placeholder');
        $elem.removeAttr('placeholder');
        config.placeholder = placeholder || ' ';
        
        $elem.select2(config)
            .on('select2:clear', () => {
                $elem[0].cleared = true;
            })
            .on('select2:opening', e => {
                if ( $elem[0].cleared ) {
                    e.preventDefault();
                    $elem[0].cleared = false;
                }
            });
    });

    // global datepicker init with automatic "dateTo" set if provided
    let displayDate = new Date('2019-06-01');
    let now = functions.cleanDate(new Date);
    if ( now > displayDate ) {
        displayDate = now;
    }

    $('.datepicker').each((i, elem) => {
        const $datepicker = $(elem);
        const minDate = $datepicker.attr('data-min');
        const maxDate = $datepicker.attr('data-max');
        $datepicker.flatpickr({
            altInput: true,
            wrap: true,
            altFormat: "j.m.Y",
            dateFormat: "Y-m-d",
            minDate: minDate ? minDate : now,
            maxDate: maxDate ? maxDate : null,
            disableMobile: true,
            prevArrow: '<i class="la la-angle-left pr-2"></i>',
            nextArrow: '<i class="la la-angle-right pl-2"></i>',
            onChange(selectedDates, dateStr, instance) {

                const $first = $(instance.input);
                // prevent other logic if second datepicker is triggered by first
                if (instance._openByFirst) {
                    delete instance._openByFirst;
                    return;
                }
                
                if ($first.attr('data-firstDate')) {
                    const $second = $first.closest('form').find('[data-secondDate]').closest('.datepicker');
                    if ($second.length) {

                        var firstDate = new Date(selectedDates[0]);
                        firstDate.setDate(firstDate.getDate() + 1);
                        
                        var secondInstance = $second[0]._flatpickr;
                        // check if firstDate is invalid
                        if (firstDate.getTime() === firstDate.getTime()) {
                            secondInstance._openByFirst = true;
                            secondInstance.set('minDate', firstDate);
                            if (!secondInstance.selectedDates[0]) {
                                firstDate.setDate(firstDate.getDate() + 6);
                                secondInstance.setDate(firstDate);
                            }
                            secondInstance.open();
                            $(secondInstance.altInput).focus();
                        }
                        else if (secondInstance.selectedDates[0]) {
                            secondInstance.clear();
                        }
                    }
                }
                // check if second date is cleared
                else if ($first.attr('data-secondDate') && !selectedDates[0]) {
                    $first.closest('form').find('[data-firstDate]').closest('.datepicker')[0]._flatpickr.clear();
                }
            },
            onOpen(selectedDates, dateStr, instance) {
                if (instance.input.getAttribute('data-secondDate')) {
                    const $first = $(instance.input).closest('form').find('[data-firstDate]').closest('.datepicker');
                    if ($first.length) {
                        const firstInstance = $first[0]._flatpickr;
                        if (!firstInstance.input.value) {
                            instance.close();
                            firstInstance.open();
                            firstInstance.altInput.focus();
                            return;
                        }
                    }
                }
                !dateStr && instance.jumpToDate(minDate ? minDate : displayDate);
            }
        });
        // to style clear toggler
        $datepicker.on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)));
    }); 

    $('.datepicker-range').each((i, elem) => {
        const $datepicker = $(elem);
        const minDate = $datepicker.attr('data-min');
        const maxDate = $datepicker.attr('data-max');
        const arrival = $datepicker.attr('data-arrival') ? $datepicker.attr('data-arrival') : [];
        const defaultDate = $datepicker.attr('data-defaultDate') ? $datepicker.attr('data-defaultDate') : [];
        const allowInput = $datepicker.attr('data-allowInput') ? true : false;
        const duration = Number($datepicker.attr('data-duration'));
        $datepicker.flatpickr({
            mode: "range",
            showMonths: functions.isMobile() ? 1 : 2,
            altInput: true,
            wrap: true,
            altFormat: "j.m.Y",
            dateFormat: "Y-m-d",
            defaultDate: defaultDate,
            minDate: minDate && minDate >= now ? minDate : now,
            maxDate: maxDate ? maxDate : null,
            disableMobile: true,
            prevArrow: '<i class="la la-arrow-circle-left la-fw la-2x pr-2"></i>',
            nextArrow: '<i class="la la-arrow-circle-right la-fw la-2x pl-2"></i>',
            allowInput: allowInput,
            locale: {
                rangeSeparator: ' - '
            },
            onDayCreate(dObj, dStr, fp, dayElem){

                let to = new Date(maxDate);
                let weekday =  new Date(dayElem.dateObj).getDay();
                weekday = '' + (weekday ? weekday : 7);
                to.setHours(0, 0, 0, 0);

                if ( dayElem.dateObj > to || (arrival.length && $.inArray( weekday , arrival ) == -1) ) {
                    dayElem.classList.add('unselectable');
                }
            },
            onChange(selectedDates, dateStr, instance) {

                /*const picker = $datepicker[0]._flatpickr;

                if(selectedDates.length < 2) {
                    const firstDate = new Date(selectedDates[0]);
                    const secondDate = new Date(firstDate.getFullYear(), firstDate.getMonth(), firstDate.getDate() + duration);

                    //instance.set('maxDate', secondDate);
    
                    picker.setDate([firstDate, secondDate], false);

                    instance.close();
                }*/

            },
        });

        // to style clear toggler
        $datepicker.on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)));
        //$datepicker.find('input:not([type="hidden"])').on('focus', e => { console.log('focus') });
    });

    // let userDates = functions.getCookie('user_dates');
    // if (userDates) 
    // {
    //     let userDateFrom = new Date(userDates.split(' - ')[0]);
    //     let today = new Date( new Date().getFullYear(), new Date().getMonth(), new Date().getDate() );
    
    //     if (userDateFrom < today) 
    //     {
    //         functions.setCookie('user_dates', '');
    //         userDates = functions.getCookie('user_dates');
    //     }
    // }

    // let datepicker = $('.datepicker-range')[0];

    // if (userDates && datepicker) 
    // {
    //     userDates = userDates.split(' - ');
    //     let dateFrom = userDates[0] ? userDates[0] : null;
    //     let dateTo = userDates[1] ? userDates[1] : null;
    
    //     if (dateFrom && dateTo) 
    //     {
    //         datepicker._flatpickr.setDate([dateFrom, dateTo]);
    //     } else if (dateFrom) 
    //     {
    //         datepicker._flatpickr.setDate([dateFrom, dateFrom]);
    //     }
    // }

    $('.side-c').css('height', $('.collapse-d').outerHeight());

    $(window).on('resize', function() {
        $('.side-c').css('height', $('.collapse-d').outerHeight());
    })

    /* gallery */
    const lg = {};
    window.showGallery = (index, id) => {
        index = +index || 0;
        if ( lg[id] ) {
            lg[id].index = index;
            lg[id].build(index);
        } else {
            let $elem = $('[data-images-' + id + ']');
            lg[id] = $elem.lightGallery({
                dynamic: true,
                thumbnail: true,
                toogleThumb: false,
                thumbWidth: 130,
                thumbMargin: 10,
                download: false,
                preload: 2,
                index: index,
                dynamicEl: JSON.parse($elem.attr('data-images-' + id))
            }).data('lightGallery');
        }
    };
    $('[data-gallery-id]').on('click', function (e) {
        e.preventDefault();
        let galleryId = $(this).attr('data-gallery-id');
        galleryId && showGallery($(this).attr('data-index'), galleryId);
    });
    // don't focus div with gallery
    $('[data-gallery-id]').on('focus', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        return false;
    });
    /* end gallery */

   


    let modalShown = functions.getCookie('user_newsletter');

    if (! modalShown)
    {
        const news = document.getElementById('newsletterModal')
        $.getScript("https://www.google.com/recaptcha/api.js?render=6Ld6Pa8UAAAAADgBzavOEcYA1Jxf6iXp8ueY6jp6");
        if(news) {
            const mod = new bootstrap.Modal(news, {
                focus: false,
            });

            news.addEventListener('hidden.bs.modal', function (event) {
                $('html').css({'overflow-y': 'overlay'});
                $('#navbarTogglerMain').attr('style', 'z-index: 1020 !important');
              })

            $(mod).on('shown.bs.modal', e => {
                $('.modal-backdrop').addClass('home-search-backdrop');
                $('.modal-open').addClass('home-search-modal-open');
                
            });
    
            setTimeout(() => {
                mod.show();
                $('html').css({'overflow-y': 'hidden'});
                $('#navbarTogglerMain').attr('style', 'z-index: auto !important');
                functions.setCookie('user_newsletter', true, (86400 * 1000));
            }, 3000);
        }
    }

    $('.newsletter-form').on('submit', function(e) {
        let $elem = this;
        e.preventDefault();
        e.stopPropagation();

       /* $($elem).find('.contact-btn').addClass('d-none');
        $($elem).find('.contact-spinner').removeClass('d-none');
        $($elem).find('.btn-newsletter').addClass('d-none');*/

        window.grecaptcha && grecaptcha.ready(function() {
            $($elem).find('.contact-btn').addClass('d-none');
            $($elem).find('.contact-spinner').removeClass('d-none');
            $($elem).find('.btn-newsletter').addClass('d-none');
            grecaptcha.execute('6Ld6Pa8UAAAAADgBzavOEcYA1Jxf6iXp8ueY6jp6', {action: 'newsletter'}).then(function(token) {
                let params = {};
                $.each($($elem).serializeArray(), function (i, field) {
                    params[field.name] = field.value;
                });

                //params['newsletter'] = false;
                //params['email'] = $form[0].email.value;
                params['language'] = functions.getLang();
    
                $.post('/services/mailchimp/', params).then(response => {
                    response = JSON.parse(response);

                    $('#contact-modal').modal('show');
                    $($elem).find(".response-output").removeClass('d-none').html(response.data);
                    $($elem).find('.contact-btn').removeClass('d-none');
                    $($elem).find('.contact-spinner').addClass('d-none');
                    $($elem).find('.btn-newsletter').removeClass('d-none');


                    setTimeout(() => { 
                        $('#contact-modal').modal('hide');
                        $($elem).find(".response-output").addClass('d-none').html('');

                    }, 5000);

                    // if (response.status == true) {
                        $elem.reset();
                    // }
                    
                });
            });
        });
    })


});






